import React, { useState } from 'react'
import { projectData } from './data'
import './portfolio.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Portfolio = () => {
  var settings = {
    dots: false,
    infinite: true,
    // speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      // {
      //   breakpoint: 600,
      //   settings: {
      //     slidesToShow: 2,
      //     slidesToScroll: 2,
      //     // initialSlide: 2
      //   }
      // },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ],
  };

  const [show, setShow] = useState(false);

  const handleClick = () => {
    setShow(prev => !prev)
  }
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Projects</h2>

      <div className='container'>
        {!show ? 
        <div className='slider'>
        <Slider {...settings}>
          {
            projectData.map((item) => {
              return (
                <div key={item.title} className='portfolio__item'>
                  <div className='portfolio__item-image '>
                    <img src={item.image1} onMouseOver={e => e.currentTarget.src = item.image2} onMouseOut={e => e.currentTarget.src = item.image1} alt={item.title} />
                  </div>
                  <div className='portfolio__item-data'>
                    <div className='front-data'>
                      <h3>{item.title}</h3>
                      <p className='portfolio_description'>
                        {item.description}
                      </p>
                    </div>
                    <div className='back-data'>
                      <div className='tech-stacks'>
                        <h4>Technologies Used</h4>
                        <p className='tech_description'>
                          {item.tech}
                        </p>
                      </div>
                      <div className='portfolio__item-buttons'>
                        <a href={item.github} target='_blank' rel='noreferrer' className='btn project-btn'>Github</a>
                        <a href={item.demo} target='_blank' rel='noreferrer' className='btn project-btn btn-primary'>Live Demo</a>
                      </div>
                    </div>

                  </div>

                </div>
              )
            })
          }
        </Slider>
        </div> :
          <div
            className='portfolio__container'
          >
            {
              projectData.map((item) => {
                return (
                  <div key={item.title} className='portfolio__item'>
                    <div className='portfolio__item-image '>
                      <img src={item.image1} onMouseOver={e => e.currentTarget.src = item.image2} onMouseOut={e => e.currentTarget.src = item.image1} alt={item.title} />
                    </div>
                    <div className='portfolio__item-data'>
                      <div className='front-data'>
                        <h3>{item.title}</h3>
                        <p className='portfolio_description'>
                          {item.description}
                        </p>
                      </div>
                      <div className='back-data'>
                        <div className='tech-stacks'>
                          <h4>Technologies Used</h4>
                          <p className='tech_description'>
                            {item.tech}
                          </p>
                        </div>
                        <div className='portfolio__item-buttons'>
                          <a href={item.github} target='_blank' rel='noreferrer' className='btn project-btn'>Github</a>
                          <a href={item.demo} target='_blank' rel='noreferrer' className='btn project-btn btn-primary'>Live Demo</a>
                        </div>
                      </div>

                    </div>

                  </div>
                )
              })
            }
          </div>
        }
        
        <center>
          {show ? <p className='btn btn-primary show-projects-btn' onClick={handleClick}>Hide Projects</p> :
            <p className='btn btn-primary show-projects-btn' onClick={handleClick}>View All Projects</p>
          }
        </center>
      </div>
    </section>
  )
}

export default Portfolio